import { CardsState } from '../types/reducers/cards'
import {
    SET_CARDS,
    SET_CARDS_LOADING,
    SET_DEFAULT_CARD,
    SetCardsAction,
    SetCardsLoadingAction,
    SetDefaultCardAction,
} from '../constants/reducers/cards'
import { Action } from '../constants/reducers/state'

export const CardsInitialState: CardsState = {
    loading: false,
    defaultCard: null,
    cards: [],
}

export const cardsReducer = (state: CardsState, action: Action): CardsState => {
    if (typeof state === 'undefined') {
        return CardsInitialState
    }

    switch (action.type) {
        case SET_CARDS_LOADING:
            return Object.assign({}, state, {
                loading: action.loading,
            })
        case SET_DEFAULT_CARD:
            return Object.assign({}, state, {
                defaultCard: action.card,
            })
        case SET_CARDS:
            return Object.assign({}, state, {
                cards: action.cards,
            })
        default:
            return state
    }
}
